import { learningServiceRequest, skip } from "./utils";

const educationLevelsService = {
  async getEducationLevels(limit = 10, page = 1, q = "") {
    return await learningServiceRequest({
      method: "get",
      url: "/education_levels",
      params: { limit, skip: skip(page, limit), q },
      failureMessage: "Error loading education levels data",
    });
  },
};

export default educationLevelsService;
